import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
const JsFieldErrorFC = ({ propName }) => {
    const { t } = useT();
    return (_jsx(Box, { p: "4px", border: "1px solid", borderRadius: "4px", borderColor: "error", children: _jsxs(Flex, { h: "64px", alignItems: "center", justifyContent: "center", children: [t('error.fieldValue'), " ", propName] }) }));
};
export const JsFieldError = memo(JsFieldErrorFC);
//# sourceMappingURL=JsFieldError.js.map